<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-9 col-sm-12">
                <form
                    class=""
                    @submit.prevent="submit"
                >

                    <div
                        id="error-message"
                        class="col-lg-12 col-sm-12 small alert alert-danger"
                        style="display: none; color: #721c24;background-color: #f8d7da;border-color: #f5c6cb;"
                    >
                        {{ trans.validation_error_message }}
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="map_type"
                    >
                        <h5>{{ trans.map_type_tl }}</h5>
                        <div class="small form-text text-muted mb-4">
                            {{ trans.help_text.map_type }}
                        </div>
                        <!-- map type -->
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label"> {{ trans.map_type }} </label>
                            <div class="col-sm-7">
                                <div class="form-check form-check-inline d-block mb-1">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        v-model="mapType"
                                        value="1"
                                        id="normalMap"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="normalMap"
                                    >
                                        {{ trans.main_map_type }}
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        v-model="mapType"
                                        value="2"
                                        id="parcelMap"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="parcelMap"
                                    >
                                        {{ trans.parcel_map_type }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- parcels -->
                        <div
                            class="form-group row"
                            v-if="mapType == 2"
                        >
                            <label class="col-sm-3 col-form-label">
                                {{ trans.parcel_map_type }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-7">
                                <select
                                    class="form-control"
                                    :disabled="canNotChangeLayer"
                                    v-model="parcel_id"
                                    @change="onChangeParcel()"
                                >
                                    <option
                                        :value="parcel.id"
                                        v-for="parcel in parcelCollection"
                                        :key="'opt-parcel-' + parcel.id"
                                    >
                                        {{ parcel.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- layers -->
                        <div
                            class="form-group row"
                            v-if="mapType == 2"
                        >
                            <label class="col-sm-3 col-form-label"> {{ trans.layer }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-7">
                                <select
                                    class="form-control"
                                    v-model="layer_id"
                                    @change="loadImageries(layer_id)"
                                    :disabled="canNotChangeLayer"
                                >
                                    <option
                                        :value="layer.id"
                                        v-for="layer in layerList"
                                        :key="'opt-layer-' + layer.id"
                                    >
                                        {{ layer.title }}
                                    </option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.layer_id"
                                >{{
                                    errors.layer_id[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="location_detail"
                    >
                        <h5>{{ trans.location_detail_setting }}</h5>
                        <div class="small form-text text-muted mb-4">
                            {{ trans.help_text.location_detail_setting }}
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.title }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="150"
                                    v-model="title"
                                />
                                <small class="form-text text-muted">
                                    {{ trans.title_150_characters }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.title"
                                >{{
                                    errors.title[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.sub_title }}
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="100"
                                    v-model="sub_title"
                                />
                                <small class="form-text text-muted">
                                    {{ trans.help_text.sub_title }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.sub_title"
                                >{{
                                    errors.sub_title[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.category }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-7">
                                <select
                                    class="form-control"
                                    v-model="category_id"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="category.id"
                                        v-for="category in upperCategories"
                                        :key="category.id"
                                    >
                                        {{ category.title }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.category }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.category_id"
                                >{{
                                    errors.category_id[0]
                                }}</span>
                            </div>
                        </div>
                        <div
                            class="form-group row"
                            v-show="subCategories.length > 0"
                        >
                            <label class="col-sm-3 col-form-label">
                                {{ trans.sub_category }}<span class="required-star"></span>
                            </label>
                            <div class="col-sm-7">
                                <select
                                    class="form-control"
                                    v-model="sub_category_id"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="subCategory.id"
                                        v-for="subCategory in subCategories"
                                        :key="subCategory.id"
                                    >
                                        {{ subCategory.title }}
                                    </option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.category_id"
                                >{{
                                    errors.category_id[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.item }}
                            </label>
                            <div class="col-sm-7">
                                <select
                                    multiple
                                    class="selectize-no-add"
                                    v-model="item_ids"
                                    name="item_ids"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="item.id"
                                        v-for="item in itemList"
                                        :key="item.id"
                                    >
                                        {{ item.title }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.item }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.item_ids"
                                >{{
                                    errors.item_ids[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.facility }}
                            </label>
                            <div class="col-sm-7">
                                <select
                                    multiple
                                    class="selectize-no-add"
                                    v-model="facility_ids"
                                    name="facility_ids"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="facility.id"
                                        v-for="facility in facilityList"
                                        :key="facility.id"
                                    >
                                        {{ facility.title }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.facility }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.facility_ids"
                                >{{
                                    errors.facility_ids[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.upper_area }}
                            </label>
                            <div class="col-sm-7">
                                <select
                                    class="form-control"
                                    v-model="area_id"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="area.id"
                                        v-for="area in areaList"
                                        :key="'area' + area.id"
                                    >
                                        {{ area.title }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.area }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.area_id"
                                >{{
                                    errors.area_id[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.tag }}
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control selectize"
                                    name="tags"
                                    v-model="tags"
                                />
                                <small class="form-text text-muted mt-0">
                                    {{ trans.help_text.tag }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.tags"
                                >{{
                                    errors.tags[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.description }}
                            </label>
                            <div class="col-sm-9">
                                <textarea
                                    class="form-control"
                                    v-model="description"
                                    rows="10"
                                ></textarea>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.description }}
                                </small>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.description"
                                >{{
                                    errors.description[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.images }}
                            </label>
                            <div class="col-sm-9">
                                <div
                                    class="upload-image-box"
                                    @dragover.prevent="dragOver"
                                    @drop.prevent="dropImages"
                                >
                                    <span>{{ trans.drag_and_drop }} </span><label
                                        class="btn btn-primary"
                                        for="uploadImages"
                                    >Browse</label>
                                    <input
                                        id="uploadImages"
                                        type="file"
                                        class="form-control-file"
                                        @change="uploadImages"
                                        multiple="multiple"
                                        hidden
                                    />
                                </div>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.images }}
                                </small>
                                <div class="row ml-1">
                                    <div
                                        class="position-relative mr-3 mt-4"
                                        v-for="(image, index) in images"
                                        :key="index"
                                    >
                                        <img
                                            :src="getImgSrc(image)"
                                            class="icon-size-4x3"
                                        />
                                        <a
                                            role="button"
                                            class="btn-remove-image text-danger"
                                            @click="removeImage(index)"
                                        ><i class="fas fa-minus-circle fa-lg"></i></a>
                                        <div class="order-button">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-info"
                                                @click="downImages(index)"
                                                :disabled="index === 0"
                                            >
                                                <i class="fa fa-arrow-left"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-info"
                                                @click="upImages(index)"
                                                :disabled="index === images.length - 1"
                                            >
                                                <i class="fa fa-arrow-right"></i>
                                            </button>
                                        </div>
                                        <span
                                            class="text-danger"
                                            v-if="getFirstError('images.' + index)"
                                        >{{
                                            getFirstError('images.' + index)
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.videos }}
                            </label>
                            <div class="col-sm-9">
                                <div class="form-group">
                                    <input
                                        type="file"
                                        class="form-control-file"
                                        @change="uploadVideos"
                                        multiple="multiple"
                                    />
                                    <small class="form-text text-muted">
                                        {{ trans.help_text.videos }}
                                    </small>
                                    <span
                                        class="text-danger"
                                        v-if="getFirstError('videos.')"
                                    >{{
                                        getFirstError('videos.')
                                    }}</span>
                                    <ul style="list-style-type: none">
                                        <li
                                            v-for="(video, index) in videos"
                                            :key="index"
                                        >
                                            <video
                                                width="320"
                                                height="240"
                                                controls
                                                v-if="typeof video == 'string'"
                                            >
                                                <source :src="'/storage/video/' + video" />
                                            </video>
                                            <span v-else>{{ video.name }}</span>
                                            <button
                                                type="button"
                                                class="btn btn-link btn-sm"
                                                @click="removeVideo(index)"
                                            >
                                                {{ trans.btn.remove }}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group">
                                    <div class="form-inline">
                                        <input
                                            type="text"
                                            class="form-control mr-2"
                                            v-model="youtubeLink"
                                        />
                                        <button
                                            type="button"
                                            class="btn btn-outline-primary"
                                            @click="addYoutubeLink"
                                        >
                                            {{ trans.btn.add_youtube_link }}
                                        </button>
                                    </div>
                                    <small class="form-text text-muted">
                                        {{ trans.right_format }}:
                                        https://www.youtube.com/embed/<strong>yourVideoCode</strong>
                                    </small>
                                    <span
                                        class="text-danger"
                                        v-if="getFirstError('links.')"
                                    >{{
                                        getFirstError('links.')
                                    }}</span>
                                </div>
                                <ul style="list-style-type: none">
                                    <li
                                        v-for="(link, index) in links"
                                        :key="index"
                                    >
                                        <div class="embed-responsive embed-responsive-21by9">
                                            <iframe
                                                class="embed-responsive-item"
                                                :src="link"
                                                allowfullscreen
                                            ></iframe>
                                        </div>
                                        <button
                                            type="button"
                                            class="btn btn-link btn-sm"
                                            @click="removeLink(index)"
                                        >
                                            {{ trans.btn.remove }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- custom fields -->
                        <hr />
                        <div class="form-group row">
                            <div class="col-sm-12">
                                <h5 class="">
                                    {{ trans.custom }}
                                </h5>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.custom }}
                                </small>
                            </div>
                        </div>
                        <div
                            class="form-group row"
                            v-for="(customField, index) in custom"
                            :key="index"
                        >
                            <div class="col-sm-3">
                                <label v-if="isFixedTitle(custom[index].title)">
                                    {{ getTitleCustomField(custom[index].title) }}
                                </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="64"
                                    v-model="custom[index].title"
                                    v-else
                                />
                                <p
                                    class="text-danger"
                                    v-if="getFirstError('custom.' + index + '.title')"
                                >
                                    {{ getFirstError('custom.' + index + '.title') }}
                                </p>
                            </div>
                            <div class="col-sm-7">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="custom[index].text"
                                    v-if="custom[index].title == trans.custom_fields.phone_number ||
                                        custom[index].title == trans.custom_fields.url
                                        "
                                />
                                <textarea
                                    rows="10"
                                    v-model="custom[index].text"
                                    class="form-control"
                                    v-else
                                ></textarea>
                                <p
                                    class="text-danger"
                                    v-if="getFirstError('custom.' + index + '.text')"
                                >
                                    {{ getFirstError('custom.' + index + '.text') }}
                                </p>
                            </div>
                            <div class="col-sm-2">
                                <a
                                    class="btn btn-outline-secondary"
                                    role="button"
                                    @click="swapCustomField('up', index)"
                                >
                                    <i
                                        class="fa fa-angle-up"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                                <a
                                    class="btn btn-outline-secondary"
                                    role="button"
                                    @click="swapCustomField('down', index)"
                                >
                                    <i
                                        class="fa fa-angle-down"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                                <a
                                    class="btn btn-outline-secondary"
                                    role="button"
                                    @click="deleteCustomField(index)"
                                >
                                    <i
                                        class="fa fa-trash"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                            </div>
                        </div>
                        <div class="form-group row justify-content-end">
                            <div class="col-sm-6">
                                <p
                                    class="text-danger"
                                    v-if="getFirstError('custom')"
                                >
                                    {{ getFirstError('custom') }}
                                </p>
                            </div>
                            <div class="col-sm-2">
                                <div
                                    class="btn-group"
                                    role="group"
                                >
                                    <button
                                        id="btnGroupDrop1"
                                        type="button"
                                        class="btn btn-secondary dropdown-toggle"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        {{ trans.btn.add_field }}
                                    </button>
                                    <div
                                        class="dropdown-menu"
                                        aria-labelledby="btnGroupDrop1"
                                    >
                                        <a
                                            role="button"
                                            class="dropdown-item"
                                            @click="addCustomField()"
                                        >Custom</a>
                                        <a
                                            role="button"
                                            class="dropdown-item"
                                            :class="{ disabled: defaultFieldIsExists(fixedTitle) }"
                                            @click="addCustomField(fixedTitle)"
                                            v-for="(fixedTitle, index) in fixedTitles"
                                            :key="index"
                                        >
                                            {{ fixedTitle }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="sns_link"
                    >
                        <h5 class="mb-1 mt-2">{{ trans.sns_link_setting }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.sns_link }}
                        </div>
                        <div
                            class="form-group row"
                            v-for="(sns, index) in sns_link"
                            :key="index"
                        >
                            <div class="col-sm-3">
                                <select
                                    class="form-control"
                                    v-model="sns.name"
                                >
                                    <option
                                        v-for="(snsOption, index) in trans.sns_link"
                                        :key="index"
                                        :value="index"
                                    >
                                        {{ snsOption }}
                                    </option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="getFirstError('sns_link.' + index + '.name')"
                                >{{ getFirstError('sns_link.' + index + '.name') }}</span>
                            </div>
                            <div class="col-sm-7">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="sns.link"
                                    placeholder="https://social_media_url"
                                />
                                <span
                                    class="text-danger"
                                    v-if="getFirstError('sns_link.' + index + '.link')"
                                >{{ getFirstError('sns_link.' + index + '.link') }}</span>
                            </div>
                            <div class="col-sm-2">
                                <a
                                    role="button"
                                    @click="addSocialField()"
                                    class="btn btn-outline-secondary"
                                ><i
                                        aria-hidden="true"
                                        class="fa fa-plus"
                                    ></i></a>
                                <a
                                    role="button"
                                    @click="deleteSocialField(index)"
                                    class="btn btn-outline-secondary"
                                ><i
                                        aria-hidden="true"
                                        class="fa fa-trash"
                                    ></i></a>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="activity_link"
                    >
                        <h5 class="mt-2 mb-1">{{ trans.activity_link_tl }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.activity_link }}
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.activity_link }}
                            </label>
                            <div class="col-sm-9">
                                <select
                                    class="selectize-no-add"
                                    multiple
                                    style="width: 100%"
                                    v-model="banner_ids"
                                    name="banner_ids"
                                >
                                    <option
                                        :value="banner.id"
                                        v-for="banner in bannerList"
                                        :key="banner.id"
                                    >
                                        {{ banner.title }}
                                    </option>
                                </select>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.activity_link }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        v-if="mapData.client.use_qr_code"
                        id="qr_setting"
                    >
                        <h5 class="mb-5 mt-2">{{ trans.qr_setting }}</h5>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.qr_image }}
                            </label>
                            <div class="col-sm-9">
                                <div
                                    class="upload-image-box"
                                    @dragover.prevent="dragOver"
                                    @drop.prevent="dropQRCodeImage"
                                >
                                    <span>{{ trans.drag_and_drop }} </span><label
                                        class="btn btn-primary"
                                        for="qrCodeFile"
                                    >Browse</label>
                                    <input
                                        id="qrCodeFile"
                                        type="file"
                                        class="d-none"
                                        accept="image/png, image/jpeg, image/svg+xml"
                                        @change="uploadQRCodeImage"
                                    />
                                </div>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.marker_image }}
                                </small>
                                <label
                                    for="qrImageFile"
                                    role="button"
                                    v-if="qr_image"
                                >
                                    <img
                                        ref="qrImage"
                                        :src="defaultQRImage"
                                        class="icon-size-100"
                                    />
                                </label>
                                <a
                                    role="button"
                                    class="text-danger align-top"
                                    @click="removeQRImage"
                                    v-if="qr_image"
                                ><i class="fas fa-minus-circle fa-lg"></i></a>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.qr_image"
                                >{{
                                    errors.qr_image[0]
                                }}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.qr_title }}
                            </label>
                            <div class="col-sm-9">
                                <input
                                    type="text"
                                    class="form-control"
                                    maxlength="100"
                                    v-model="qr_title"
                                />
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.qr_title"
                                >{{
                                    errors.qr_title[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        v-if="mapData.client.use_audio_guide"
                        id="audio_guide"
                    >
                        <h5 class="mb-1 mt-2">{{ trans.audio_guide_tl }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.audio_guide }}
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.audio_guide }}
                            </label>
                            <div class="col-sm-9">
                                <select
                                    class="form-control"
                                    v-model="audio_guide_id"
                                    name="audio_guide_id"
                                >
                                    <option
                                        selected
                                        value=""
                                    >Choose...</option>
                                    <option
                                        :value="audio.id"
                                        v-for="audio in audioGuideList"
                                        :key="audio.id"
                                    >
                                        {{ audio.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        v-if="mapData.client.use_congestion"
                        id="congestion"
                    >
                        <h5 class="mb-1 mt-2">{{ trans.congestion_tl }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.congestion }}
                        </div>
                        <div class="form-group row mt-3 mb-3">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.congestion }}
                            </label>
                            <div class="col-sm-9 mt-2">
                                <div class="d-flex align-items-center custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        id="congestionEnable"
                                        v-model="enable_congestion"
                                        class="custom-control-input"
                                    />
                                    <label
                                        for="congestionEnable"
                                        class="custom-control-label text-muted"
                                    >{{ trans.congestion_enable }}</label>
                                    <a
                                        :class="[
                                            'btn btn-xs ml-4',
                                            congestion.congestion_schedules.length > 0
                                                ? 'btn-success'
                                                : 'btn-warning'
                                        ]"
                                        v-if="enable_congestion && congestion && congestion.enable"
                                        target="_blank"
                                        :href="`/congestions/${congestion.id}/schedule`"
                                    >
                                        {{
                                            congestion.congestion_schedules.length > 0
                                            ? 'Active'
                                            : 'Setting'
                                        }}
                                    </a>
                                </div>
                                <div class="custom-control custom-switch mt-3">
                                    <input
                                        type="checkbox"
                                        id="congestionTooltip"
                                        v-model="show_tooltip_congestion"
                                        class="custom-control-input"
                                    />
                                    <label
                                        for="congestionTooltip"
                                        class="custom-control-label text-muted"
                                    >{{ trans.congestion_show_tooltip }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="marker_setting"
                    >
                        <h5 class="mb-1 mt-2">{{ trans.marker_setting }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.marker_sub }}
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.marker_image }}
                            </label>
                            <div class="col-sm-9">
                                <div
                                    class="upload-image-box"
                                    @dragover.prevent="dragOver"
                                    @drop.prevent="dropMarkerImage"
                                >
                                    <span>{{ trans.drag_and_drop }} </span><label
                                        class="btn btn-primary"
                                        for="markerImageFile"
                                    >Browse</label>
                                    <input
                                        id="markerImageFile"
                                        type="file"
                                        class="d-none"
                                        accept="image/png, image/jpeg, image/svg+xml"
                                        @change="uploadMarkerImage"
                                    />
                                </div>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.marker_image }}<br />
                                    {{ trans.help_text.marker_image_default }}
                                </small>
                                <div class="row my-4">
                                    <div class="col-sm-3">
                                        <label
                                            for="markerImageFile"
                                            role="button"
                                        >
                                            <img
                                                ref="markerImage"
                                                :src="marker_image ? defaultMarkerImage : '/img/no-marker-image.png'"
                                                class="icon-size-100 bg-checkers"
                                            />
                                        </label>
                                        <a
                                            role="button"
                                            class="text-danger align-top"
                                            @click="removeMarkerImage"
                                            v-if="marker_image"
                                        ><i class="fas fa-minus-circle fa-lg"></i></a>
                                        <span
                                            class="text-danger"
                                            v-if="errors && errors.marker_image"
                                        >{{
                                            errors.marker_image[0]
                                        }}</span>
                                    </div>
                                    <div class="col-sm-9 align-self-end">
                                        <div
                                            class="btn btn-primary btn-sm"
                                            @click="applyCategoryImage()"
                                        >{{ trans.apply_category_image }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row my-2">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.marker_style }}
                            </label>
                            <div class="col-sm-3">
                                <select
                                    class="form-control"
                                    v-model="marker_style"
                                    @change="applyMarker($event.target.value)"
                                >
                                    <option
                                        :value="markerStyle"
                                        v-for="markerStyle in markerStyles"
                                        :key="markerStyle"
                                    >
                                        {{ markerStyle == 'illustration' ? 'rich_custom' : markerStyle }}
                                    </option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.marker_style"
                                >{{
                                    errors.marker_style[0]
                                }}</span>
                            </div>
                        </div>
                        <div
                            class="form-group row my-2"
                            v-show="marker_style == 'illustration'"
                        >
                            <div class="col-sm-3"></div>
                            <div class="col-sm-6">
                                <label class="col-form-label">
                                    {{ trans.illustration_image }}
                                </label>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    @change="uploadIllustrationImage"
                                >
                                <div class="row my-3 mx-1">
                                    <img
                                        ref="illustrationImage"
                                        :src="defaultIllustrationImage"
                                        style="max-width:200px"
                                    />
                                    <span
                                        class="text-danger"
                                        v-if="errors && errors.illustration_image"
                                    >{{
                                        errors.illustration_image[0]
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="form-group row my-2"
                            v-show="marker_style == 'illustration'"
                        >
                            <div class="col-sm-3"></div>
                            <div class="col-sm-6">
                                <label class="col-form-label">
                                    {{ trans.illustration_image_width_size }}<span class="required-star"></span>
                                </label>
                                <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    step="1"
                                    class="form-control"
                                    v-model="illustration_image_width_size"
                                />
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.illustration_image_width_size"
                                >{{
                                    errors.illustration_image_width_size[0]
                                }}</span>
                            </div>
                        </div>
                        <div
                            class="form-group row my-2"
                            v-show="marker_style == 'illustration'"
                        >
                            <div class="col-sm-3"></div>
                            <div class="col-sm-6">
                                <label class="col-form-label">
                                    {{ trans.illustration_image_custom_style_css }}
                                </label>
                                <textarea
                                    class="form-control"
                                    v-model="illustration_image_custom_style_css"
                                ></textarea>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.illustration_image_custom_style_css"
                                >{{
                                    errors.illustration_image_custom_style_css[0]
                                }}</span>
                            </div>
                        </div>
                        <div
                            class="form-group row my-2"
                            v-show="marker_style == 'illustration'"
                        >
                            <div class="col-sm-3"></div>
                            <div class="col-sm-6 align-self-end">
                                <button
                                    class="btn btn-outline-primary mt-auto ml-2"
                                    type="button"
                                    @click="applyMarker('illustration')"
                                >
                                    {{ trans.btn.apply_preview }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- location coordinates -->
                    <div
                        class="col-lg-12 col-sm-12 bg-white shadow-sm rounded-lg border mb-3 p-3 step-content"
                        id="location_map_setting"
                    >
                        <h5 class="mb-1 mt-2">{{ trans.location_map_setting }}</h5>
                        <div class="small form-text text-muted mb-5">
                            {{ trans.help_text.location_map_setting }}
                        </div>
                        <div class="form-group row">
                            <div
                                id="geocoder-container"
                                class="d-none"
                            ></div>
                            <label class="col-sm-3 col-form-label">
                                {{ trans.address }}
                            </label>
                            <div class="col-sm-9">
                                <div class="d-flex">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="address"
                                    />
                                    <button
                                        @click="$refs.mySmartMap.queryLocation(address)"
                                        type="button"
                                        class="btn btn-outline-primary mt-auto ml-1 w-25"
                                    >
                                        {{ trans.btn.search }}
                                    </button>
                                </div>
                                <small class="form-text text-muted">
                                    {{ trans.help_text.search }}
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.map_coordinates }}
                            </label>
                            <div class="col-sm-9 pl-3">
                                <div class="row d-flex">
                                    <div class="">
                                        <span> {{ trans.latitude }} </span>
                                        <input
                                            type="number"
                                            min="-90"
                                            max="90"
                                            step="any"
                                            class="form-control"
                                            v-model="lat"
                                        />
                                    </div>
                                    <div class="ml-2">
                                        <span> {{ trans.longtitude }} </span>
                                        <input
                                            type="number"
                                            min="-180"
                                            max="180"
                                            step="any"
                                            class="form-control"
                                            v-model="lng"
                                        />
                                    </div>
                                    <button
                                        class="btn btn-outline-primary mt-auto ml-2"
                                        type="button"
                                        :disabled="!lngLatIsValid"
                                        @click="
                                            changeMarkerCoordinates([lng, lat]);
                                        $refs.mySmartMap.setFlyToForMarker(
                                            defaultMarkerCoordinates
                                        );
                                        "
                                    >
                                        {{ trans.btn.apply }}
                                    </button>
                                </div>
                                <p class="text-danger">
                                    <span v-if="!lngLatIsValid && !errors.lng && !errors.lat">Longtitude must be between
                                        -180 and 180. Latitude must be
                                        between -90 and 90</span>
                                    <span v-else-if="errors && errors.lng">{{
                                        errors.lng[0]
                                    }}</span>
                                    <span v-else-if="errors && errors.lat">{{
                                        errors.lat[0]
                                    }}</span>
                                </p>
                            </div>
                            <div class="col-sm-12 pl-3">
                                <div v-if="tokenIsValid">
                                    <map-preview
                                        ref="mySmartMap"
                                        :access-token="mapData.mapbox_token"
                                        :zoom-level="mapData.zoom_level"
                                        :map-style="mapData.style"
                                        :has-marker="true"
                                        :draggable="true"
                                        :coordinates="defaultMarkerCoordinates"
                                        :marker-coordinates="defaultMarkerCoordinates"
                                        @updatedMarkerCoordinates="changeMarkerCoordinates"
                                        v-if="mapType == 1"
                                        :admin-lang="adminLang"
                                        :marker-source="markerSource"
                                        :map-data="mapData"
                                    ></map-preview>
                                    <parcel-map-preview
                                        ref="mySmartMap"
                                        :access-token="mapData.mapbox_token"
                                        :zoom-level="currentParcel.min_zoom"
                                        :map-style="mapData.style"
                                        :has-marker="true"
                                        :draggable="true"
                                        :coordinates="currentParcel.coordinates"
                                        :marker-coordinates="defaultMarkerCoordinates"
                                        :layer-resource="currentLayer"
                                        @updatedMarkerCoordinates="changeMarkerCoordinates"
                                        v-if="mapType == 2 && currentLayer"
                                        :admin-lang="adminLang"
                                        :marker-source="markerSource"
                                        :map-data="currentParcel"
                                    ></parcel-map-preview>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="col-lg-3 col-sm-12">
                <div class="side-stickey">
                    <div class=" bg-white shadow-sm card rounded-lg border border-secondary">
                        <div class="card-body">
                            <div
                                class=""
                                id="autoTranslate"
                                v-if="mapData.use_auto_translate"
                            >
                                <div class="form-group mt-3 mb-3">
                                    <label class="col-form-label">
                                        {{ trans.auto_translate }}
                                    </label>
                                    <div class="mt-2">
                                        <div class="custom-control custom-switch">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="customSwitchAutoTranslate"
                                                v-model="use_auto_translate"
                                            />
                                            <label
                                                class="custom-control-label text-muted"
                                                for="customSwitchAutoTranslate"
                                            >{{ isTranslateTxt }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class=""
                                id="status"
                            >
                                <div class="form-group mt-3 mb-3">
                                    <label class="col-form-label">
                                        {{ trans.status }}
                                    </label>
                                    <div class="mt-2">
                                        <div class="custom-control custom-switch">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="customSwitch1"
                                                v-model="status"
                                            />
                                            <label
                                                class="custom-control-label text-muted"
                                                for="customSwitch1"
                                            >{{ statusTxt }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button
                                @click="disabledSubmitBtn"
                                class="btn btn-primary w-100 submit-btn"
                                :disabled="isDisabled"
                            >
                                {{ locationData ? trans.btn.update : trans.btn.create }}
                                <div
                                    v-if="isDisabled && use_auto_translate && mapData.use_auto_translate"
                                    class="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </button>
                        </div>
                    </div>
                    <ul class="steps text-xs mx-3 list-unstyled">
                        <li class="step"><a
                                href="#map_type"
                                class="link-secondary"
                            >{{ trans.map_type_tl }}</a></li>
                        <li class="step"><a href="#location_detail">{{ trans.location_detail_setting }}</a></li>
                        <li class="step"><a href="#sns_link">{{ trans.sns_link_setting }}</a></li>
                        <li class="step"><a href="#activity_link">{{ trans.activity_link_tl }}</a></li>
                        <li
                            class="step"
                            v-if="mapData.client.use_qr_code"
                        ><a href="#qr_setting">{{ trans.qr_setting }}</a></li>
                        <li
                            class="step"
                            v-if="mapData.client.use_audio_guide"
                        ><a href="#audio_guide">{{ trans.audio_guide_tl }}</a></li>
                        <li
                            class="step"
                            v-if="mapData.client.use_congestion"
                        ><a href="#congestion">{{ trans.congestion_tl }}</a></li>
                        <li class="step"><a href="#marker_setting">{{ trans.marker_setting }}</a></li>
                        <li class="step"><a href="#location_map_setting">{{ trans.location_map_setting }}</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapPreview from './MapPreview';
import CheckAccessToken from '../mixins/MapBox/CheckAccessToken';
import axios from 'axios';
import selectize from 'selectize';
import ParcelMapPreview from './ParcelMapPreview';

export default {
    props: {
        isEdit: {
            type: Boolean,
            default: false
        },
        mapData: {
            type: Object,
            required: true
        },
        locationData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        formAction: {
            type: String,
            required: true
        },
        categories: {
            type: Array,
            default: function () {
                return [];
            }
        },
        itemList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        items: {
            type: Array,
            default: function () {
                return [];
            }
        },
        facilityList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        facilities: {
            type: Array,
            default: function () {
                return [];
            }
        },
        bannerList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        areaList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        banners: {
            type: Array,
            default: function () {
                return [];
            }
        },
        trans: {
            type: Object,
            required: true
        },
        parcelCollection: {
            type: Array,
            default: function () {
                return [];
            }
        },
        audioGuideList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        congestion: {
            type: Object,
            default: function () {
                return null;
            }
        },
        illustrationImageResource: {
            type: Object,
            default: function () {
                return {};
            }
        },
        adminLang: {
            type: String,
            default: '',
        },
        canNotChangeLayer: {
            type: Boolean,
            default: false
        }
    },
    mixins: [CheckAccessToken],
    components: {
        MapPreview,
        ParcelMapPreview
    },
    data() {
        return {
            status: false,
            enable_congestion: this.congestion ? this.congestion.enable : false,
            show_tooltip_congestion: this.congestion ? this.congestion.show_tooltip : false,
            title: '',
            sub_title: '',
            category_id: '',
            sub_category_id: '',
            item_ids: [],
            facility_ids: [],
            area_id: '',
            banner_ids: [],
            audio_guide_id: '',
            tags: '',
            description: '',
            address: '',
            markerStyles: ['round', 'square', 'icon', 'custom', 'illustration', 'point'],
            lng: 135,
            lat: 35,
            custom: [],
            marker_image: null,
            marker_style: 'round',
            videos: [],
            links: [],
            images: [],
            remove_old: {
                marker_image: false,
                images: [],
                videos: [],
                qr_image: false,
                illustration_image: false,
            },
            youtubeLink: '',
            defaultMarkerCoordinates: [],
            mapType: 1,
            parcel_id: '',
            currentParcel: null,
            layerList: [],
            currentLayer: null,
            layer_id: '',
            errors: {},
            isDisabled: false,
            sns_link: [{ name: '', link: '' }],
            qr_image: null,
            qr_title: '',
            use_auto_translate: false,
            use_category_image: '',
            illustration_image: null,
            illustration_image_width_size: 100,
            illustration_image_custom_style_css: '',
            markerSource: [],
        };
    },
    computed: {
        lngLatIsValid() {
            return Math.abs(this.lng) <= 180 && Math.abs(this.lat) <= 90;
        },
        defaultMarkerImage() {
            if (this.isEdit && this.locationData.marker_image) {
                return this.locationData.marker_image_url;
            }
            if (!this.isEdit && this.use_category_image) {
                return this.marker_image;
            }
            return '/img/no-image.jpg';
        },
        fixedTitles() {
            return Object.values(this.trans.custom_fields);
        },
        statusTxt() {
            let status = this.status ? 1 : 0;

            return this.trans.status_val[status];
        },
        isTranslateTxt() {
            return this.use_auto_translate ? 'On' : 'Off'
        },
        upperCategories() {
            // Normal map
            if (this.mapType == 1) {
                return this.categories.filter((item) => {
                    return (item.is_on_main_map || !item.is_limit) && !item.upper_category_id;
                });
            }
            // Parcel map
            return this.categories.filter((item) => {
                let isCategoryParcel = item.parcels.some((parcel) => parcel.id == this.parcel_id);
                return ((item.parcels.length > 0 && isCategoryParcel) || !item.is_limit) && !item.upper_category_id;
            });
        },
        subCategories() {
            let lowerCategories = this.categories.find((item) => {
                return item.id === this.category_id;
            });
            return lowerCategories && lowerCategories.lower_categories ? lowerCategories.lower_categories : [];
        },
        defaultQRImage() {
            return this.isEdit && this.locationData.qr_image
                ? this.locationData.qr_image_url
                : '/img/no-image.jpg';
        },
        defaultIllustrationImage() {
            return this.isEdit && this.locationData.marker_style == 'illustration' && this.illustrationImageResource
                ? this.illustrationImageResource.image_url
                : '/img/no-image.jpg';
        },
    },
    methods: {
        disabledSubmitBtn(event) {
            var self = this;
            setTimeout(() => {
                event.target.disabled = self.isDisabled;
            }, 50);
        },
        prepareFormData() {
            let formData = new FormData();
            if (this.subCategories.length > 0) {
                this.category_id = this.sub_category_id;
            }
            formData.append('status', this.status ? 1 : 0);
            formData.append('enable_congestion', this.enable_congestion ? 1 : 0);
            formData.append('show_tooltip_congestion', this.show_tooltip_congestion ? 1 : 0);
            formData.append('title', this.title);
            formData.append('sub_title', this.sub_title);
            formData.append('category_id', this.category_id);
            formData.append('item_ids', JSON.stringify(this.item_ids));
            formData.append('facility_ids', JSON.stringify(this.facility_ids));
            formData.append('area_id', this.area_id);
            formData.append('tags', this.tags);
            formData.append('description', this.description);
            formData.append('banner_ids', JSON.stringify(this.banner_ids));
            formData.append('map_type', this.mapType);
            if (this.mapData.client.use_audio_guide) {
                formData.append('audio_guide_id', this.audio_guide_id);
            }
            if (this.marker_image instanceof File) {
                formData.append('marker_image', this.marker_image);
            }
            formData.append('marker_style', this.marker_style);
            formData.append('lng', this.lng);
            formData.append('lat', this.lat);
            const imagesLen = this.images.length;
            for (let i = 0; i < imagesLen; i++) {
                const element = this.images[i];
                if (this.isEdit && typeof element == 'string') {
                    formData.append('current_images[' + i + ']', element);
                    continue;
                }
                formData.append('images[' + i + ']', element.file);
            }
            const videosLen = this.videos.length;
            for (let i = 0; i < videosLen; i++) {
                const element = this.videos[i];
                if (this.isEdit && typeof element == 'string') {
                    continue;
                }
                formData.append('videos[' + i + ']', element);
            }
            const linksLen = this.links.length;
            for (let i = 0; i < linksLen; i++) {
                const element = this.links[i];
                formData.append('links[' + i + ']', element);
            }
            const customLen = this.custom.length;
            for (let i = 0; i < customLen; i++) {
                const element = this.custom[i];
                formData.append('custom[' + i + '][title]', element.title);
                formData.append('custom[' + i + '][text]', element.text);
            }
            if (this.mapType == 2) {
                formData.append('layer_id', this.layer_id);
                formData.append('parcel_id', this.parcel_id);
            }

            if (this.isEdit) {
                formData.append('_method', 'PUT');
                formData.append('remove_old', JSON.stringify(this.remove_old));
            }

            const snsLen = this.sns_link.length;
            for (let i = 0; i < snsLen; i++) {
                const element = this.sns_link[i];
                if (!element.name && !element.link) {
                    continue;
                }
                formData.append('sns_link[' + i + '][name]', element.name);
                formData.append('sns_link[' + i + '][link]', element.link);
            }

            if (this.qr_image instanceof File) {
                formData.append('qr_image', this.qr_image);
            }
            formData.append('qr_title', this.qr_title);
            formData.append('use_auto_translate', this.use_auto_translate ? 1 : 0);
            formData.append('use_category_image', this.use_category_image ? 1 : 0);
            if (this.illustration_image instanceof File) {
                formData.append('illustration_image', this.illustration_image);
            }
            formData.append('illustration_image_width_size', this.illustration_image_width_size);
            formData.append('illustration_image_custom_style_css', this.illustration_image_custom_style_css ?? '');
            formData.append('previous_url', document.referrer);
            return formData;
        },
        submit() {
            if (this.mapData.use_auto_translate
                && this.locationData
                && this.use_auto_translate
                && !confirm(this.trans.confirm_translation)) {
                this.isDisabled = false;
                return;
            }
            this.isDisabled = true;
            var self = this;
            axios({
                method: 'POST',
                url: this.formAction,
                data: this.prepareFormData(),
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        setTimeout(() => {
                            window.location.replace(response.data.redirectTo);
                        }, 2000);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                    document.getElementById('error-message').style.display = 'block';
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
        },
        getFirstError(field) {
            if (this.errors.length == 0) {
                return;
            }
            for (const key in this.errors) {
                if (key == field) {
                    return this.errors[key][0];
                }
            }
            return;
        },
        getImgSrc(image) {
            if (typeof image == 'string') {
                let result =
                    /^https?:\/\/(?:[a-z0-9\-]+|[:\.])+([0-9]|[a-z]{2,6})(?:\/[^\/#?]+)+\.(?:jpe?g|svg|png)$/.test(
                        image
                    );
                return result ? image : '/storage/image/' + image;
            }

            return image.result;
        },
        isYoutubeLink(str) {
            const pattern = /^https:\/\/(?:www\.)?youtube.com\/embed\/[A-z0-9]+/;
            return str.match(pattern);
        },
        changeMarkerCoordinates(val) {
            this.defaultMarkerCoordinates = val;
        },
        fetchLocationData() {
            this.status = this.locationData.status;
            this.title = this.locationData.title;
            this.sub_title = this.locationData.sub_title;
            const category = this.categories.find((el) => el.id == this.locationData.category_id);
            if (category.upper_category_id) {
                this.category_id = category.upper_category_id;
                this.sub_category_id = category.id;
            } else {
                this.category_id = category.id;
            }
            this.area_id = this.locationData.area_id ? this.locationData.area_id : '';
            this.tags = this.locationData.tags;
            this.description = this.locationData.description;
            this.marker_image = this.locationData.marker_image;
            this.marker_style = this.locationData.marker_style;
            this.lng = this.locationData.lng;
            this.lat = this.locationData.lat;
            this.images = this.locationData.images;
            this.audio_guide_id = this.locationData.audio_guide_id ? this.locationData.audio_guide_id : '';
            this.qr_image = this.locationData.qr_image;
            this.qr_title = this.locationData.qr_title;
            this.illustration_image = this.marker_style == 'illustration' && this.illustrationImageResource ? this.illustrationImageResource.image : '';
            this.illustration_image_width_size = this.marker_style == 'illustration' && this.illustrationImageResource ? this.illustrationImageResource.width_size : '';
            this.illustration_image_custom_style_css = this.marker_style == 'illustration' && this.illustrationImageResource ? this.illustrationImageResource.custom_style_css : '';
            this.markerSource.push(this.illustration_image && this.illustrationImageResource ? this.illustrationImageResource.image_url : '');
            this.markerSource.push(this.illustration_image_width_size);
            this.markerSource.push(this.illustration_image_custom_style_css);

            const videoLens = this.locationData.videos ? this.locationData.videos.length : 0;
            for (let i = 0; i < videoLens; i++) {
                const element = this.locationData.videos[i];
                if (this.isYoutubeLink(element)) {
                    this.links.push(element);
                } else {
                    this.videos.push(element);
                }
            }

            const facilityLength = this.locationData.facilities
                ? this.locationData.facilities.length
                : 0;
            for (let i = 0; i < facilityLength; i++) {
                this.facility_ids.push(this.locationData.facilities[i].id);
            }
            this.custom = this.locationData.custom_fields;

            for (let i = 0; i < this.items.length; i++) {
                this.item_ids.push(this.items[i].id);
            }
            for (let i = 0; i < this.banners.length; i++) {
                this.banner_ids.push(this.banners[i].id);
            }
            if (this.locationData.layer_id) {
                this.mapType = 2;
                this.parcelCollection.forEach((parcel) => {
                    parcel.layers.forEach((layer) => {
                        if (this.locationData.layer_id == layer.id) {
                            this.currentParcel = parcel;
                            this.parcel_id = parcel.id;
                            this.layerList = parcel.layers;
                            this.currentLayer = layer;
                            this.layer_id = layer.id;
                        }
                    });
                });
            }
            if (this.locationData.sns_link.length > 0) {
                this.sns_link = this.locationData.sns_link;
            }
            this.use_auto_translate = this.locationData.use_auto_translate;
        },
        fetch() {
            this.lng = this.mapData.lng;
            this.lat = this.mapData.lat;
            if (this.isEdit) {
                this.fetchLocationData();
            }
            this.changeMarkerCoordinates([this.lng, this.lat]);
        },
        isFixedTitle(title) {
            const { custom_fields, custom_fields_fixed } = this.trans;
            return Object.values(custom_fields).includes(title) || Object.values(custom_fields_fixed).includes(title);
        },
        getTitleCustomField(title) {
            const { custom_fields, custom_fields_fixed } = this.trans;
            let index = Object.values(custom_fields).indexOf(title);
            let indexFixed = Object.values(custom_fields_fixed).indexOf(title);
            return custom_fields[Object.keys(custom_fields)[index]] || custom_fields[Object.keys(custom_fields_fixed)[indexFixed]];
        },
        swapCustomField(move, index) {
            var startDeleteAt;
            var elements;
            switch (move) {
                case 'up':
                    if (index == 0) return;
                    startDeleteAt = index - 1;
                    elements = [this.custom[index - 1], this.custom[index]];
                    break;
                case 'down':
                    if (index == this.custom.length - 1) return;
                    startDeleteAt = index;
                    elements = [this.custom[index], this.custom[index + 1]];
                    break;

                default:
                    return;
            }

            this.custom.splice(startDeleteAt, 2, elements[1], elements[0]);
        },
        addCustomField(title) {
            this.custom.push({
                title: title ? title : '',
                text: ''
            });
        },
        deleteCustomField(index) {
            this.custom.splice(index, 1);
        },
        addSocialField() {
            this.sns_link.push({
                name: '',
                link: ''
            });
        },
        deleteSocialField(index) {
            this.sns_link.splice(index, 1);
        },
        defaultFieldIsExists(title) {
            const found = this.custom.find((element) => element.title == title);

            return found !== undefined;
        },
        dragOver(event) { },
        dropMarkerImage(event) {
            this.uploadMarkerImage(event);
        },
        uploadMarkerImage(e) {
            const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
            if (!file.type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) {
                alert('File is invalid, allowed extensions are: jpg, jpeg, png, svg');
                return;
            }

            var self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.$refs.markerImage.src = e.target.result;
            };
            reader.readAsDataURL(file);
            this.marker_image = file;
            this.use_category_image = false;
            if (this.isEdit) {
                this.remove_old.marker_image = true;
            }
        },
        removeMarkerImage() {
            this.marker_image = null;
            this.$refs.markerImage.src = '/img/no-image.jpg';
            if (this.isEdit) {
                this.remove_old.marker_image = true;
            }
        },
        applyCategoryImage() {
            let category = this.categories.find(e => e.id === (this.sub_category_id || this.category_id));
            this.marker_image = category.icon_url;
            this.use_category_image = true;
            this.remove_old.marker_image = true;
            setTimeout(() => {
                this.$refs.markerImage.src = category.icon_url;
            }, 500);
        },
        dropImages(event) {
            this.uploadImages(event);
        },
        uploadImages(e) {
            const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
            for (let i = 0; i < files.length; i++) {
                if (!files[i].type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) {
                    alert('File is invalid, allowed extensions are: jpg, jpeg, png, svg');
                    return;
                }
                this.images.push({
                    file: files[i],
                    result: URL.createObjectURL(files[i])
                });
            }
        },
        removeImage(index) {
            const image = this.images[index];
            const isOldImage = this.isEdit && typeof image == 'string';
            if (isOldImage) {
                this.remove_old.images.push(image);
            }
            this.images.splice(index, 1);
        },
        uploadVideos(e) {
            const file = e.target.files[0];
            if (!file.type.match(/.(mp4)$/i)) {
                alert('File is invalid, allowed extensions are: MP4');
                return;
            }
            if (file.size / 1024 / 1024 > 25) {
                alert('File must be under 25MB');
                return;
            }

            this.videos.push(file);
        },
        addYoutubeLink() {
            let link = 'https://www.youtube.com/embed/' + this.youtubeLink;
            if (!this.isYoutubeLink(link)) {
                alert('Link is invalid, only accept youtube link');
                return;
            }
            this.links.push(link);
            this.youtubeLink = '';
        },
        removeVideo(index) {
            const video = this.videos[index];
            const isOldvideo = this.isEdit && typeof video == 'string';
            if (isOldvideo) {
                this.remove_old.videos.push(video);
            }
            this.videos.splice(index, 1);
        },
        removeLink(index) {
            this.links.splice(index, 1);
        },
        bindingSelectizeFields() {
            var self = this;
            $('.selectize').selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                create: function (input) {
                    return {
                        value: input,
                        text: input
                    };
                },
                onChange: function (value) {
                    const field = this.$input['0'].name;
                    self[field] = value;
                }
            });

            $('.selectize-no-add').selectize({
                plugins: ['remove_button'],
                delimiter: ',',
                persist: false,
                onChange: function (value) {
                    const field = this.$input['0'].name;
                    self[field] = value;
                }
            });
        },
        onChangeParcel() {
            const found = this.parcelCollection.find((element) => element.id == this.parcel_id);
            if (!found) return;

            [this.currentParcel, this.layerList] = [found, found.layers];
            if (!this.isEdit) {
                this.defaultMarkerCoordinates = this.currentParcel.coordinates;
            }
        },
        loadImageries(layerId) {
            const found = this.layerList.find((element) => element.id == layerId);
            if (!found) return;
            this.currentLayer = found;
        },
        upImages(index) {
            this.moveImages(index, index + 1);
        },
        downImages(index) {
            this.moveImages(index, index - 1);
        },
        moveImages(from, to) {
            this.images.splice(to, 0, this.images.splice(from, 1)[0])
        },
        dropQRCodeImage(event) {
            this.uploadQRCodeImage(event)
        },
        uploadQRCodeImage(e) {
            const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
            if (!file.type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) {
                alert('File is invalid, allowed extensions are: jpg, jpeg, png, svg');
                return;
            }

            var self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.$refs.qrImage.src = e.target.result;
            };
            reader.readAsDataURL(file);
            this.qr_image = file;
            if (this.isEdit) {
                this.remove_old.qr_image = true;
            }
        },
        removeQRImage() {
            this.qr_image = null;
            this.$refs.qrImage.src = '/img/no-image.jpg';
            if (this.isEdit) {
                this.remove_old.qr_image = true;
            }
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                    });
                }
            }
        },
        uploadIllustrationImage(e) {
            const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
            if (!file.type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) {
                alert('File is invalid, allowed extensions are: jpg, jpeg, png, svg');
                return;
            }

            var self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.$refs.illustrationImage.src = e.target.result;
            };
            reader.readAsDataURL(file);
            this.illustration_image = file;
            if (this.isEdit) {
                this.remove_old.illustration_image = true;
            }
        },
        applyMarker(type) {
            let routeUrl = window.location.href.split('/');
            let href = routeUrl[0] + '//' + routeUrl[2] + '/img/no-image.jpg';
            let markerImage = (type == 'illustration' && this.$refs.illustrationImage.src != '/img/no-image.jpg' && this.$refs.illustrationImage.src != href)
                ? this.$refs.illustrationImage.src
                : null;
            if (markerImage != null && (!this.illustration_image_width_size || this.illustration_image_width_size < 1 || this.illustration_image_width_size > 100)) {
                alert(this.trans.alert_width_size);
                return;
            }
            var result = [];
            result.push(markerImage);
            result.push(this.illustration_image_width_size);
            result.push(this.illustration_image_custom_style_css);
            this.markerSource = result;
            this.getIllustrationImageSize();
        },
        getIllustrationImageSize() {
            let img = new Image();
            var self = this;
            img.onload = function () {
                self.markerSource.push(this.width);
                self.markerSource.push(this.height);
            }
            img.src = this.markerSource[0];
        }
    },
    watch: {
        defaultMarkerCoordinates() {
            this.lng = this.defaultMarkerCoordinates[0];
            this.lat = this.defaultMarkerCoordinates[1];
        }
    },
    created() {
        this.fetch();
    },
    mounted() {
        this.clickSubmitBtn();
        this.bindingSelectizeFields();
        this.checkAccessToken(this.mapData.mapbox_token);
        this.getIllustrationImageSize();
    }
};
</script>

<style src='selectize/dist/css/selectize.default.css'></style>
<style src='selectize/dist/css/selectize.bootstrap3.css'></style>

<style>
.btn-remove-image {
    position: absolute;
    top: -5%;
    left: 90%;
}

.select2-selection__choice {
    background-color: #007bff !important;
}

.upload-image-box {
    width: 100%;
    height: 200px;
    border: 2px dashed;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.order-button {
    display: flex;
    justify-content: flex-end;
    transform: translateY(-50%);
}

.step a {
    color: #6c757D;
}

@media screen and (max-width: 990px) {
    .steps {
        display: none;
    }
}

.side-stickey {
    position: sticky;
    top: 2rem;
    right: 0;
    z-index: 2;
    overflow-y: auto;
}

.tab-content {
    padding-left: 0px !important;
}

.bg-checkers {
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='%23d3d1d7' fill-opacity='0.4'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E");
}
</style>